import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { PagedList, Petition, User, DataTablesResponse, DatatableRootObject, PolicyHolder, Value, PetitionItem, petitionDatatableItem } from '../interfaces/interfaces.index';
import { buildUrlPaged } from '../shared/config/commons';
import { Codebtor } from '../interfaces/codebtors.interface';
const endpoint = `${URL_SERVICIOS}Petition`;

@Injectable({
  providedIn: 'root'
})

export class PeticionService {

  constructor(public http: HttpClient) { }

  addPetitionAdviserStore = (petition: Petition) => sessionStorage.setItem('selPetition', JSON.stringify(petition));

  getPetitionByAdviser = (tableObj: DatatableRootObject, adviserUserId: number) => this.http.post<DataTablesResponse<petitionDatatableItem>>(`${URL_SERVICIOS}Petition/PetitionByAdviser?ConcessionaireId=${adviserUserId}`, tableObj, HTTP_OPTIONS)

  getPetitions = (page?: number, limit?: number, nextPages?: number, offset?: number) =>
    this.http.get<PagedList<Petition>>(`${endpoint}${buildUrlPaged(page, limit, nextPages, offset)}`, HTTP_OPTIONS)

  getPetitionById = (id: number) => this.http.get<Petition>(`${endpoint}/${id}`, HTTP_OPTIONS);

  getPetitionsByUser = (user: User) => this.http.get<Petition[]>(`${endpoint}/all/user/${user.id}`, HTTP_OPTIONS);

  getPetitionsByUserDirect = (id: Number) => this.http.get<Petition[]>(`${endpoint}/all/user/${id}`, HTTP_OPTIONS);


  getPetitionsByStatus = (status: number, page?: number, limit?: number, nextPages?: number, offset?: number) =>
    this.http.get<PagedList<Petition>>
      (`${endpoint}/processStatus/${status}${buildUrlPaged(page, limit, nextPages, offset)}`, HTTP_OPTIONS)

  getPetitiondDatatables = (tableObj: DatatableRootObject) =>
    this.http.post<DataTablesResponse<Petition>>(`${ endpoint }/datatable`, tableObj, HTTP_OPTIONS)

  getPolicyHolderById = (id: number) => this.http.get<PolicyHolder>(`${URL_SERVICIOS}PolicyHolder/${id}`, HTTP_OPTIONS);

  getPetitionAllByUser = (user: User) => this.http.get<Petition[]>(`${endpoint}/all/user/${user.id}`, HTTP_OPTIONS);

  putUpdatePetitionStatus = (petitionId: number, statusPetition: string) => this.http.put<Petition>(`${endpoint}/status?petitionId=${petitionId}&statusPetition=${statusPetition}`, HTTP_OPTIONS);

  getValueByPetition = (petitionId: number) =>
  this.http.get<Value>(`${endpoint}/ValueByPetition/${petitionId}`, HTTP_OPTIONS)

  addInsuranceManagement = (petition) =>
    this.http.post(`${endpoint}/InsuranceManagementLog`, petition, HTTP_OPTIONS);

  putInsuranceManagement = (petition, petitionId: number) =>
  this.http.put(`${endpoint}/InsuranceManagement/${petitionId}`, petition, HTTP_OPTIONS);

  addCodebtor = (petitionId, codebtors: Codebtor[]) =>
  this.http.post(`${endpoint}/CoDebtors/${petitionId}`, codebtors, HTTP_OPTIONS);

  getCodebtorPetition = (userId: number) => this.http.get<Petition>(`${endpoint}/CoDebtor/${userId}`, HTTP_OPTIONS);

  getPetitionsList = (userId: number) => this.http.get<PetitionItem[]>(`${endpoint}/all/${userId}`, HTTP_OPTIONS);

}
